import React from "react";
import { svgShape } from "../shapes";

const svgProps = (size, className) => {
  return {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    role: "presentation",
    className: className,
  };
};

const CaretIcon = ({ size, styleProps, className }) => {
  return (
    <svg
      viewBox="0 0 18 18"
      {...svgProps(size || 18, className)}
      style={styleProps}
    >
      <path d="M16.5 13.5L9 5.9l-7.4 7.4-.8-.7L9 4.5l8.2 8.2z" />
    </svg>
  );
};

CaretIcon.propTypes = svgShape;

const SearchIcon = ({ size, styleProps, className }) => (
  <svg
    viewBox="0 0 24 24"
    {...svgProps(size || 36, className)}
    style={styleProps}
  >
    <path
      d="M10.055 2a8.055 8.055 0 1 0 5.07 14.305l5.45 5.45a.836.836 0 0 0 1.18 0 .825.825 0 0 0 0-1.171l-5.45-5.451A8.052 8.052 0 0 0 10.055 2zM10 3.5A6.5 6.5 0 1 1 3.5 10 6.487 6.487 0 0 1 10 3.5z"
      fillRule="evenodd"
    />
  </svg>
);

SearchIcon.propTypes = svgShape;

const ArrowIcon = ({ size, styleProps, className }) => (
  <svg
    viewBox="0 0 32 32"
    {...svgProps(size || 32, className)}
    style={styleProps}
  >
    <path d="M29.436 16.492l-6.5 7.5a.726.726 0 0 1-.56.26.75.75 0 0 1-.57-1.24l5.42-6.26h-24.1a.75.75 0 1 1 0-1.5h24.1l-5.42-6.26a.748.748 0 0 1 .08-1.06.736.736 0 0 1 1.05.08l6.5 7.5a.734.734 0 0 1 0 .98z" />
  </svg>
);

ArrowIcon.propTypes = svgShape;

const SmallArrowIcon = ({ size, styleProps, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    {...svgProps(size || 16, className)}
    style={styleProps}
  >
    <path d="M15.43242,8.03373,10.54136,3.14267A.75.75,0,0,0,9.4807,4.20333l3.07309,3.07309L1.6205,7.21A.75025.75025,0,0,0,1.612,8.71043l10.958.06576L9.4807,11.86554a.75.75,0,0,0,1.06066,1.06066Z" />
  </svg>
);

SmallArrowIcon.propTypes = svgShape;

const CloseIcon = ({ size, styleProps, className }) => (
  <svg
    viewBox="0 0 18 18"
    {...svgProps(size || 18, className)}
    style={styleProps}
  >
    <path d="M13.419 3.873L8.823 8.47 4.404 4.05l-.707.707 4.419 4.42-4.243 4.242.708.708 4.242-4.243 4.42 4.419.707-.707-4.42-4.419 4.597-4.596-.708-.708z" />
  </svg>
);

CloseIcon.propTypes = svgShape;

const ExternalIcon = ({ size, styleProps, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    {...svgProps(size || 16, className)}
    style={styleProps}
  >
    <path d="M13.285 2.766H6.368a.75.75 0 0 0 0 1.5h4.346L2.936 11.95a.75.75 0 1 0 1.055 1.067l7.795-7.702v4.369a.75.75 0 0 0 1.5 0z" />
  </svg>
);

ExternalIcon.propTypes = svgShape;

const CheckIcon = ({ size, styleProps, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    {...svgProps(size || 16, className)}
    role="img"
    style={styleProps}
  >
    <path d="M5.974 12L2.857 8.952l1.039-1.015 2.078 2.032L12.104 4l1.039 1.016L5.974 12z" />
  </svg>
);

CheckIcon.propTypes = svgShape;

export {
  CaretIcon,
  SearchIcon,
  ArrowIcon,
  SmallArrowIcon,
  CloseIcon,
  ExternalIcon,
  CheckIcon,
};
